import { Capacitor } from "@capacitor/core";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
//
// ⚠️ PLACEHOLDERS — replace with your real Google Cloud OAuth client IDs before building the
// native apps. The Web client ID must match GOOGLE_WEB_CLIENT_ID in backend/.env (used to
// verify the idToken server-side). See /app/MOBILE_GOOGLE_AUTH.md for setup steps.
export const GOOGLE_WEB_CLIENT_ID = "YOUR_GOOGLE_WEB_CLIENT_ID.apps.googleusercontent.com";
export const GOOGLE_IOS_CLIENT_ID = "YOUR_GOOGLE_IOS_CLIENT_ID.apps.googleusercontent.com";

export const isNativeApp = () => Capacitor.isNativePlatform();

let initialized = false;

// Performs a native Google Sign-In (Capacitor iOS/Android) and returns the Google idToken.
export async function nativeGoogleSignIn() {
  const { SocialLogin } = await import("@capgo/capacitor-social-login");
  if (!initialized) {
    await SocialLogin.initialize({
      google: {
        webClientId: GOOGLE_WEB_CLIENT_ID,
        iOSClientId: GOOGLE_IOS_CLIENT_ID,
        iOSServerClientId: GOOGLE_WEB_CLIENT_ID,
        mode: "online",
      },
    });
    initialized = true;
  }
  const { result } = await SocialLogin.login({ provider: "google", options: {} });
  const idToken = result?.idToken;
  if (!idToken) throw new Error("Google did not return an idToken");
  return idToken;
}
